import { AnimatePresence, motion } from "motion/react";
import { CSSProperties } from "react";
import clsx from "clsx";
import { cn } from "@/core/helpers/cn";

type Props = {
  char: string;
  label: string;
  isActive?: boolean;
  showLabel?: boolean;
  className?: string;
  style?: CSSProperties;
};

export default function HudHint({
  className,
  label,
  char,
  isActive,
  showLabel = true,
  style,
}: Props) {
  return (
    <div className={cn("flex items-center gap-2.5", className)} style={style}>
      <AnimatePresence>
        {showLabel ? (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className={clsx("text-15 text-white/70 font-medium whitespace-nowrap")}
            exit={{ opacity: 0 }}
          >
            {label}
          </motion.div>
        ) : null}
      </AnimatePresence>

      <div
        className={clsx(
          "w-8 h-7 text-12 text-white font-extrabold flex items-center justify-center shrink-0",
          "bg-dark-900/60 rounded-[0.375rem]",
          isActive ? "brightness-110" : "",
        )}
      >
        {char}
      </div>
    </div>
  );
}
